import React, {Component} from 'react';
import { compose, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';
import Typography from '@material-ui/core/Typography';

import { toggleSaveEditPopup, toggleNotification, showRemoveModal } from '../../redux/reducers/view';
import { resetPathToSaveVersion, saveVersionRequest, overwriteVersionRequest, learnerVersionsRequest } from '../../redux/reducers/savedVersions';

import Popup from '../Popup';
import SaveEditForm from '../Form/SaveEditForm';

import { commonStyles } from '../../styles/styles';
import questions from '../../assets/questions-circular.svg';
import VersionNameField from '../Form/VersionNameField';
import { Field, reduxForm } from 'redux-form';
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBIcon } from 'mdbreact';
import { validateSaveEditPassword } from '../Form/validate';
import { resetSaveEditForm } from '../../redux/reducers/annotations';
import { versionStatusRequest } from '../../redux/reducers/versionStatus';
import { selectedVersion, selectedContent, getSelectedThinktool } from '../../redux/selectors';
import { xapiRequest } from '../../redux/reducers/xapi';
import axios from 'axios';
import { API_LINK } from '../../constants';
const API = `${API_LINK}api`;


class RemoveVersion extends Component {
  state = {
    modal: true
  };

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
    this.props.showRemoveModal(false)
  }
  render() {
    return (
      <MDBContainer >
        <MDBModal isOpen={this.props.view.showRemoveModal} toggle={this.toggle}  centered  >

          <MDBModalHeader style={{textAlign:'left', margin: 5}} className="default-color text-white" toggle={this.toggle}><div style={{color: '#ffffff !important'}}>REMOVE VERSION</div> </MDBModalHeader>
         
          <MDBModalBody>
          <div className="mb-2 mt-2">
           Are you sure you would like to remove this version?
          </div>
  
          </MDBModalBody>
          <MDBModalFooter>
          <MDBBtn
            className="btn-dark-green"
            size='sm'
            type="submit"
            onClick={() => this.props.handleRemove()}
            >
            REMOVE
            </MDBBtn>
      
            <MDBBtn
              size='sm'
            
              onClick={() => this.props.showRemoveModal(false)}
              color='secondary'
            >
              CANCEL
            </MDBBtn>
          
          </MDBModalFooter>
         
        </MDBModal>
      </MDBContainer>
    );
  }
}


const styles = () => ({
  ...commonStyles,
  image: {
    width: 64,
    height: 64,
  },
});

const mapStateToProps = state => ({
  formState: state.form,
  savedVersions: state.savedVersionsReducer,
  userProgramsFull: state.userProgramsFullReducer,
  view: state.viewReducer,
  version: selectedVersion(state),
  loginReducer: state.loginReducer,
  selectedContent: getSelectedThinktool(state),
});
const mapDispatchToProps = dispatch => ({
  saveVersionRequest: () => dispatch(saveVersionRequest()),
  resetSaveEditForm: () => dispatch(resetSaveEditForm()),
  toggleSaveEditPopup: value => dispatch(toggleSaveEditPopup(value)),
  showRemoveModal: value => dispatch(showRemoveModal(value)),
  toggleNotification: value => dispatch(toggleNotification(value)),
  overwriteVersionRequest: () => dispatch(overwriteVersionRequest()),
  resetPathToSaveVersion: () => dispatch(resetPathToSaveVersion()),
  versionStatusRequest: () => dispatch(versionStatusRequest()),
  xapiRequest: xapiType => dispatch(xapiRequest(xapiType)),
  learnerVersionsRequest: () => dispatch(learnerVersionsRequest()),
});

export default compose(
  reduxForm({
    form: 'saveEdit',
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    handleSaveEdit: props => values => {
      props.xapiRequest({ xapiType: `Saved`});
      validateSaveEditPassword(values);
      props.saveVersionRequest();
    },
    handleRemove: props => async() => {
      var result =  await axios({
        method: 'get',
        url: `${API}/removeVersion/${props.view.removeId}`,
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: `Bearer ${props.loginReducer.token}`,
        }
      })
      props.learnerVersionsRequest();
      props.showRemoveModal(false)
    },
    onClearClick: props => () => {
      const { resetPathToSaveVersion, toggleSaveEditPopup } = props;
      props.resetPathToSaveVersion();
      toggleSaveEditPopup(false);
    },
  }),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      const {
        toggleNotification,
        toggleSaveEditPopup,
        savedVersions,
        versionStatusRequest,
      } = nextProps;
      
      if (savedVersions.isVersionSaved && !this.props.savedVersions.isVersionSaved && this.props.userProgramsFull.item.type !='Journal') {
        
        toggleNotification({
          value: true,
          message: 'Version was saved successfully',
          type: 'success',
        });
        this.props.resetPathToSaveVersion();
        toggleSaveEditPopup(false);
        versionStatusRequest();
      }
      if (savedVersions.isOverwriteVersion && !this.props.savedVersions.isOverwriteVersion && this.props.userProgramsFull.item.type !='Journal') {
        
        toggleNotification({
          value: true,
          message: 'Version was overwritten successfully',
          type: 'success',
        });
        this.props.resetPathToSaveVersion();
        toggleSaveEditPopup(false);
        versionStatusRequest();
      }
    },
  }),
  withStyles(styles),
)(RemoveVersion);

